import { Button } from '@customerio/pluma-components/react';
import { useOpenFlexRecharge } from '../hooks/use-open-flex-recharge';
import clsx from 'clsx';
import { FlexMark, leadingMarkButton } from '@/components/flex-mark';
import * as styles from './segments-addon-button.css';

type FlexRechargeButtonProps = {
  usedPercent: number;
};

/** The Credits Lifecycle prototype's "Flex recharge" tag, offered under the agent usage readout. */
export function FlexRechargeButton({ usedPercent }: FlexRechargeButtonProps) {
  const openFlexRecharge = useOpenFlexRecharge();

  return (
    <Button
      className={clsx(styles.flexTag, leadingMarkButton)}
      size="sm"
      elementBefore={<FlexMark />}
      onClick={() => void openFlexRecharge(usedPercent)}
    >
      Flex recharge
    </Button>
  );
}
